import { Component, ComponentInterface, h, Element, State, Prop, Host } from '@stencil/core';

@Component({
  tag: 'jui-tooltip',
  styleUrl: 'jui-tooltip.scss',
  shadow: true
})
export class JuiToolTip implements ComponentInterface {
  @Element() htmlElement!: HTMLElement;

  @Prop() dataId!: string;

  @State() visible = false;

  @State() tooltipLeft = false;

  @State() tooltipLeftBottom = false;

  @State() tooltipTop = 0;

  private targetHtmlElement: HTMLElement;

  componentDidLoad() {
    this.targetHtmlElement = document.querySelector(`[data-tooltip="${this.dataId}"]`) as HTMLElement;

    if (this.targetHtmlElement) {
      this.targetHtmlElement.addEventListener('mouseenter', this.showTooltip);
      this.targetHtmlElement.addEventListener('mouseleave', this.hideTooltip);
    }
  }

  disconnectedCallback() {
    if (this.targetHtmlElement) {
      this.targetHtmlElement.removeEventListener('mouseenter', this.showTooltip);
      this.targetHtmlElement.removeEventListener('mouseleave', this.hideTooltip);
    }
  }

  render() {
    return (
      <Host>
        <div
          class={{
            'tooltip': true,
            'tooltip__visible': this.visible,
            'tooltip__left': this.tooltipLeft,
            'tooltip__left__bottom': this.tooltipLeftBottom
          }}
          style={{ top: `${this.tooltipTop}px` }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }

  private showTooltip = () => {
    this.visible = true;
    this.renderTooltipTop();
    this.renderTooltips();
  };

  private hideTooltip = () => {
    this.visible = false;
  };

  private renderTooltips(): void {
    this.tooltipLeft = this.renderTooltipOnLeft(this.targetHtmlElement);
    if (this.tooltipLeft) {
      this.tooltipLeftBottom = this.renderTooltipOnBottom(this.targetHtmlElement);
    }
  }

  renderTooltipOnLeft = (element: HTMLElement): boolean => {

    const elementBounds = element.getBoundingClientRect();
    if (elementBounds.width === 0) {
      return false;
    }
    const windowWidth = window.innerWidth;
    const inputDistanceFromRightEdge = windowWidth - (elementBounds.left + elementBounds.width);

    return inputDistanceFromRightEdge < 100;
  };

  renderTooltipOnBottom = (element: HTMLElement): boolean => {

    const elementBounds = element.getBoundingClientRect();
    if (elementBounds.width === 0) {
      return false;
    }

    return elementBounds.top < 100;
  };

  renderTooltipTop = () => {
    const elementBounds = this.targetHtmlElement.getBoundingClientRect();
    this.tooltipTop = elementBounds.top + 25;
  }
}
